import styled from 'styled-components';
import Typography from '@/components/Typography';
import { TextStyles } from '@/constants';

export const TrackingCarrierListWrapper = styled.div(({ theme }) => ({
  display: 'grid',
  flexDirection: 'column',
  gridRowGap: theme.spacing[16],
  paddingTop: theme.spacing[16],
}));

export const TrackingCarrierWrapper = styled.div(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr',
  gridColumnGap: theme.spacing[16],
}));

export const TrackingCarrierName = styled(Typography).attrs({
  variant: TextStyles['Heading 3'],
})`
  color: ${({ theme }) => theme.colors.highEmphasisBlack};
  margin-bottom: ${({ theme }) => theme.spacing[8]};
`;

export const TrackingCarrierHyperlinkWrapper = styled.div`
  display: flex;
  align-items: center;

  > img {
    margin-right: ${({ theme }) => theme.spacing[8]};
  }
`;

export const TrackingCarrierHyperlink = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
  type: 'a',
})`
  color: ${({ theme }) => theme.colors.hyperlink};
  text-decoration: underline;
`;

export const TrackingCarrierPhone = styled(TrackingCarrierHyperlinkWrapper)`
  margin-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const TrackingCarrierWebsite = styled(TrackingCarrierHyperlink)`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
